import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c(VFlex,{staticClass:"mx-auto text-center",attrs:{"xs8":""}},[_c('h2',{staticClass:"my-4",domProps:{"innerHTML":_vm._s(_vm.dataAdaptaclima.titulo)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.dataAdaptaclima.texto)}})]),_c(VFlex,{staticClass:"mx-auto text-center mt-8",attrs:{"xs8":""}},[_c('img',{attrs:{"src":_vm.$store.state.rutaApi+_vm.dataAdaptaclima.imagen,"alt":"logos","width":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }